/*
  Buy Now button
  Adds the current variant to the cart, then redirects straight to checkout,
  skipping the cart page. Kept separate from the Add to Cart button and the
  Shop Pay / dynamic checkout button.
*/
(function () {
  function initBuyNowButtons() {
    document.querySelectorAll('[data-buy-now-button]').forEach(function (button) {
      if (button.dataset.buyNowInitialized) return;
      button.dataset.buyNowInitialized = 'true';
      button.addEventListener('click', handleBuyNowClick);
    });
  }

  function handleBuyNowClick(evt) {
    const button = evt.currentTarget;
    if (button.classList.contains('loading')) return;

    const form = button.closest('form');
    if (!form) return;

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = new FormData(form);

    fetch(`${window.routes.cart_add_url}`, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          alert(response.description || 'Something went wrong. Please try again.');
          return;
        }

        window.location.href = '/checkout';
      })
      .catch(function (e) {
        console.error(e);
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        alert('Something went wrong. Please try again.');
      });
  }

  initBuyNowButtons();
})();
